<ion-header class="ion-no-border">
	<ion-toolbar>

		<ion-buttons slot="start">
			<ion-button (click)="close()">
				<fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>

		<ion-title>Smartpay reader</ion-title>

        <ion-buttons slot="end" *ngIf="online && !selected_reader">
            <ion-button (click)="pairReader()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>

	</ion-toolbar>
</ion-header>

<ion-content>

    <ion-grid *ngIf="!online" class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <p>
                    <fa-icon [icon]="['fal', 'wifi-slash']" size="6x"></fa-icon>
                    <span>You are not connected to the internet</span>
                </p>
            </ion-col>
		</ion-row>
	</ion-grid>

    <ion-grid *ngIf="online" class="form">
        <ion-row *ngIf="selected_reader">
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <p>You are already paired to a Smartpay reader.</p>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <p>Your Smartpay reader will think it's still paired until you unpair the reader through the reader's config menu.</p>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-button (click)="forgetReader()">Forget reader</ion-button>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>        
        <ion-row *ngIf="!selected_reader">
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-input class="modal-input" label="Pairing code" labelPlacement="stacked" fill="outline" [(ngModel)]="pairing_code"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <p><a href="https://www.smartpay.co.nz/wp-content/uploads/MAR-620-0421-GSG-SmartConnect-PTS-190.pdf" target="_blank">How do I get a pairing code?</a></p>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>
    
</ion-content>